<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="uEElyRBSRY2EnZHJFvdT238">
<p class="perfect-center"><span class="charoverride"><br class="calibre1"/></span></p>
<p class="perfect-center"><span class="charoverride">NO ANGELS</span></p>
<p class="perfect-center"><span class="charoverride1"><br class="calibre1"/></span></p>
<p class="perfect-center"><span class="charoverride1">The Short Life and Brutal Death of Brandaline Rose DuVall</span></p>
<p class="perfect-center"><span class="charoverride"><br class="calibre1"/></span></p>
<p class="perfect-center"><span class="charoverride"><br class="calibre1"/></span></p>
<p class="perfect-center"><span class="charoverride">STEVE JACKSON</span></p>
<p class="perfect-center">
<img alt="" class="calibre2" src="Images/NA_080.jpg"/>
</p>
<p class="perfect-center1" id="calibre_pb_0"><a href="http://WildBluePress.com" target="_blank">WildBluePress.com</a><br class="calibre3"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NA_002.vue?568d645b